import { MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";

interface VenueMapProps {
  name?: string;
  address: string;
  directions?: string;
}

const VenueMap = ({ name, address, directions }: VenueMapProps) => {
  const q = encodeURIComponent(address);
  const embed = `https://maps.google.com/maps?q=${q}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${q}`;

  return (
    <div className="rounded-xl border border-sky-100 overflow-hidden bg-white shadow-sm">
      <div className="aspect-[16/9] bg-slate-100 w-full">
        <iframe
          title={`Map to ${name || address}`}
          src={embed}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-full border-0"
          allowFullScreen
        />
      </div>
      <div className="p-4 space-y-2">
        {name && (
          <p className="font-semibold text-slate-800 inline-flex items-center gap-2">
            <MapPin className="w-4 h-4 text-amber-600" /> {name}
          </p>
        )}
        <p className="text-sm text-slate-600 whitespace-pre-line">{address}</p>
        {directions && (
          <div className="text-sm text-slate-700 bg-sky-50/60 border border-sky-100 rounded-md p-3 whitespace-pre-line">
            <span className="font-semibold text-sky-700">How to reach: </span>
            {directions}
          </div>
        )}
        <div className="pt-1">
          <Button asChild size="sm" className="bg-sky-600 hover:bg-sky-700 text-white">
            <a href={directionsUrl} target="_blank" rel="noopener noreferrer">
              <Navigation className="w-4 h-4 mr-2" /> Get Directions
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VenueMap;
